class PDProductsSlider {
    constructor() {
        this.slider = document.querySelector('.pd-products__slider')
        this.prevButton = document.querySelector('.pd-prev')
        this.nextButton = document.querySelector('.pd-next')

        if (!this.slider) return

        // Calculate card width including gap
        this.cardWidth = this.calculateCardWidth()

        // Add event listeners
        if (this.prevButton) {
            this.prevButton.addEventListener('click', () => this.scroll('prev'))
            this.prevButton.style.cursor = 'pointer'
        }

        if (this.nextButton) {
            this.nextButton.addEventListener('click', () => this.scroll('next'))
            this.nextButton.style.cursor = 'pointer'
        }

        // Recalculate on resize
        window.addEventListener('resize', () => {
            this.cardWidth = this.calculateCardWidth()
        })

        // Update button visibility on scroll
        this.slider.addEventListener('scroll', () => this.updateButtons())
        this.updateButtons()
    }

    calculateCardWidth() {
        const firstCard = this.slider.querySelector('.pd-card')
        if (!firstCard) return 0

        const cardStyle = window.getComputedStyle(firstCard)
        const gap = parseFloat(window.getComputedStyle(this.slider).gap) || 0
        const cardWidth = firstCard.offsetWidth

        return cardWidth + gap
    }

    scroll(direction) {
        const scrollAmount = this.cardWidth
        const currentScroll = this.slider.scrollLeft
        const maxScroll = this.slider.scrollWidth - this.slider.clientWidth

        let targetScroll
        if (direction === 'next') {
            targetScroll = Math.min(currentScroll + scrollAmount, maxScroll)
        } else {
            targetScroll = Math.max(currentScroll - scrollAmount, 0)
        }

        this.slider.scrollTo({
            left: targetScroll,
            behavior: 'smooth',
        })
    }

    updateButtons() {
        const scrollLeft = this.slider.scrollLeft
        const maxScroll = this.slider.scrollWidth - this.slider.clientWidth
        const threshold = 1 // Small threshold for rounding errors

        if (this.prevButton) {
            this.prevButton.style.opacity =
                scrollLeft <= threshold ? '0.5' : '1'
            this.prevButton.style.pointerEvents =
                scrollLeft <= threshold ? 'none' : 'auto'
        }

        if (this.nextButton) {
            this.nextButton.style.opacity =
                scrollLeft >= maxScroll - threshold ? '0.5' : '1'
            this.nextButton.style.pointerEvents =
                scrollLeft >= maxScroll - threshold ? 'none' : 'auto'
        }
    }
}

// Initialize slider when DOM is ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
        new PDProductsSlider()
    })
} else {
    new PDProductsSlider()
}
